import * as types from '../mutation-types'
import { helpers } from '../../api/http-common'

export const defaultState = {
  r_configured: false,
  binaries_enabled: false,
  display_ash: false,
  custom_home: false,
  custom_home_html: '',
  ga_id: '',
  distros: undefined,
  cranRepo: undefined,
  biocVersions: undefined,
  version: '',
  build_date: '',
  gettingMetricsStatus: false,
  metricsEnabled: false,
  latestVersionUpdateSeen: 'none',
  latestVersionUpdate: '',
  showLatestUpdate: false,
}

export const mutations = {
  [types.RECEIVE_STATUS] (state, { status }) {
    state.r_configured = status.r_configured
    state.binaries_enabled = status.binaries_enabled
    state.distros = status.distros
    state.cranRepo = status.cran_repo
    state.biocVersions = status.bioc_versions
    state.display_ash = status.display_ash
    state.build_date = status.build_date
    state.custom_home = status.custom_home
    state.ga_id = status.ga_id
  },
  [types.SET_GETTING_VERSION] (state) {
    state.version = ''
  },
  [types.RECEIVE_VERSION] (state, { version }) {
    state.version = version
  },
  [types.SET_GETTING_METRICS_STATUS] (state, flag) {
    state.gettingMetricsStatus = flag
  },
  [types.RECEIVE_METRICS_STATUS] (state, params) {
    state.metricsEnabled = params.status.metrics_enabled
  },
  [types.SET_LATEST_VERSION_UPDATE_SEEN] (state, version) {
    state.latestVersionUpdateSeen = version
  },
  [types.SET_LATEST_VERSION_UPDATE] (state, version) {
    state.latestVersionUpdate = version
  },
  [types.SHOW_LATEST_UPDATE] (state, flag) {
    state.showLatestUpdate = flag
  },
  [types.SET_GETTING_CUSTOM_PAGE] (state, flag) {
    if (flag) {
      state.custom_home_html = ''
    }
  },
  [types.RECEIVE_CUSTOM_PAGE] (state, { contents }) {
    state.custom_home_html = contents
  },
}

const module = HTTP => ({
  state: defaultState,
  mutations,
  actions: {
    async getStatus ({ commit }) {
      try {
        commit(types.SET_GETTING_METRICS_STATUS, true)
        commit(types.SET_GETTING_VERSION)

        const response = await HTTP.get('/status')
        const status = response.data

        // Update metrics
        commit(types.RECEIVE_METRICS_STATUS, { status })
        commit(types.SET_GETTING_METRICS_STATUS, false)

        // Update version
        if (status.version) {
          commit(types.RECEIVE_VERSION, { version: 'v ' + status.version })
        }

        // remove distros that are hidden from the UI
        status.distros = status.distros.filter(distro => {
          return !distro.hidden
        })

        // make sure the currently selected OS is in the list of distros
        commit(types.VERIFY_SELECTED_OS, status.distros)

        // make sure the currently selected BioC version is in the list of BioC versions
        commit(types.VERIFY_SELECTED_BIOC_VERSION, status.bioc_versions)

        // Update global status
        commit(types.RECEIVE_STATUS, { status: status })
      } catch (e) {
        commit(types.SET_GETTING_METRICS_STATUS, false)
        console.log(e)
      }
    },
    async getCustomPage ({ commit }, params) {
      try {
        // Are we running in production?
        const { isApiProd } = helpers.environments(process.env.API_ENV, process.env.NODE_ENV)
        const url = isApiProd ? `/custom/${params.page}` : `${params.page}/${params.page}.html`
        commit(types.SET_GETTING_CUSTOM_PAGE, true)
        const response = await HTTP.get(url)
        const customPageContents = response.data
        commit(types.RECEIVE_CUSTOM_PAGE, { contents: customPageContents })
        commit(types.SET_GETTING_CUSTOM_PAGE, false)
      } catch (e) {
        commit(types.SET_GETTING_CUSTOM_PAGE, false)
        console.log(e)
      }
    },
  },
})

export default {
  module,
}
